import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 border-t border-navy-800 py-12" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-68">
        <div className="text-center md:text-left" data-id="element-69">
          <h3 className="font-heading font-bold text-2xl text-white mb-1" data-id="element-70">
            THE DOCK WALL
          </h3>
          <p className="text-gray-500 text-sm" data-id="element-71">
            © 2024 The Dock Wall. All rights reserved.
          </p>
        </div>

        <div className="flex gap-6" data-id="element-72">
          <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-73">
            <Instagram className="w-6 h-6" data-id="element-74" />
          </a>
          <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-75">
            <Facebook className="w-6 h-6" data-id="element-76" />
          </a>
          <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-77">
            <Twitter className="w-6 h-6" data-id="element-78" />
          </a>
        </div>

        <div className="flex gap-6 text-sm text-gray-500" data-id="element-79">
          <a href="#" className="hover:text-white transition-colors" data-id="element-80">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-81">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}